import { gameInstance } from '@Game/GameComponent';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { TStateResolver } from '@Managers/StateMachine/StateMachine.types';
import { EWinPresentationStates } from './WinPresentationStates';

export const completeWinPresentationResolver: TStateResolver<EWinPresentationStates> = () => {
    return EWinPresentationStates.WIN_PRESENTATION_HIDDEN_STATE;
};

export const winPresentationIdleResolver: TStateResolver<EWinPresentationStates> = () => {
    const { isSkipped, isTerminated, currentSublevelIndex } = gameInstance.gameStore.get(EGameStoreKeys.WinPresentation);
    const { finalSublevelIndex } = gameInstance.gameStore.get(EGameStoreKeys.WinPresentation);

    if (isTerminated) return EWinPresentationStates.POST_WIN_PRESENTATION_STATE;
    if (isSkipped && currentSublevelIndex !== finalSublevelIndex) return EWinPresentationStates.WIN_PRESENTATION_IDLE_STATE;
    if (currentSublevelIndex === finalSublevelIndex) return EWinPresentationStates.WIN_PRESENTATION_HOLD_STATE;
    else return EWinPresentationStates.WIN_PRESENTATION_IN_STATE;
};

export const winHoldStateResolver: TStateResolver<EWinPresentationStates> = () => {
    const { isTerminated } = gameInstance.gameStore.get(EGameStoreKeys.WinPresentation);
    if (isTerminated) return EWinPresentationStates.POST_WIN_PRESENTATION_STATE;

    return EWinPresentationStates.WIN_PRESENTATION_OUT_STATE;
};

export const winPresentationOutResolver: TStateResolver<EWinPresentationStates> = () => {
    return EWinPresentationStates.POST_WIN_PRESENTATION_STATE;
};
